import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import { LANGUAGES, LanguageKey } from "shared/constants";

//translation files
import app_it from "_translations/italian/app.json";
import contractTranslation_it from "_translations/italian/contracts.json";
import b2bTranslation_it from "_translations/italian/b2b.json";
import preBillingTranslation_it from "_translations/italian/pre-billing.json";
import app_eng from "_translations/english/app.json";
import contractTranslation_eng from "_translations/english/contracts.json";
import b2bTranslation_eng from "_translations/english/b2b.json";
import preBillingTranslation_eng from "_translations/english/pre-billing.json";
import dashboard_it from "_translations/italian/dashboard.json";
import dashboard_en from "_translations/english/dashboard.json";

const getDefaultLanguage = () => {
    var userLang: string = navigator.language;
    //alert ("The language is: " + userLang);
    return userLang === "it-IT" ? LANGUAGES.get(LanguageKey.IT)!.id! : LANGUAGES.get(LanguageKey.EN)!.id;
}

const resources = {
    it: {
        app: app_it,
        contract: contractTranslation_it,
        b2b: b2bTranslation_it,
        preBilling: preBillingTranslation_it,
        dashboard: dashboard_it
    },
    en: {
        app: app_eng,
        contract: contractTranslation_eng,
        b2b: b2bTranslation_eng,
        preBilling: preBillingTranslation_eng,
        dashboard: dashboard_en
    }
};

i18next.use(initReactI18next)
    .init({
        resources: resources,
        lng: getDefaultLanguage() // default language
    });


export default i18next;